module.exports = __webpack_public_path__ + "static/media/kn.c81c1cb3.svg";